import React from "react";
import Card from "../Card/Card";
import { useTranslation } from "react-i18next";
import { PieChartLegend } from "../Charts/PieChart/PieChartLegend";
import { platformDataTransform } from "../Charts/PieChart/PieChart.utils";
import { chartStyling } from "../DataVisualization.styled";

const ApplicantPlatforms = ({ platforms, language, totalAmount }) => {
  const { t } = useTranslation();

  return (
    <Card
      cardKey="applicantPlatforms"
      title={t("Applicant Platforms")}
      fullWidth
      expandAttentionBox={false}
      wrapperHeight={420}
    >
      <PieChartLegend
        t={t}
        arrayData={platforms}
        language={language}
        totalAmount={totalAmount}
        transformFunc={platformDataTransform}
        styling={chartStyling}
      />
    </Card>
  );
};

export default ApplicantPlatforms;
